// ChartCard.tsx
import { ReactNode } from "react";
import '../Customers.scss'
import { Button } from "antd";
import { DownloadOutlined, DownOutlined } from "@ant-design/icons";

export const ChartCard = ({
    title,
    children,
}: {
    title: string;
    children: ReactNode;
}) => {
    return (
        <div className="custom-pape-css w-full h-full flex flex-column justify-between  rounded-2 p-4 border"
            style={{ border: '1px solid #eaebec' }}
        >
            <div className="custom-pape-css  flex justify-between items-center ">
                <h3 className="custom-page-css text-base text-344054 font-medium "
                style={{
                    height: 52
                }}
                
                >{title}</h3>
            </div>
            <div className="custom-pape-css w-full h-full flex flex-1 justify-center items-center">
                {children}
            </div>
        </div>
    );
};
